import { IAppState } from '../../common/state';

export const getSnippetBrokerFlow = ({ newbuildingInformation }: IAppState) =>
  newbuildingInformation?.newbuildingBroker?.availableBrokerFlow || undefined;
